import React, { useEffect } from "react";
import { TawkChat } from "@/components";

const TrueConnectionsScreen: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="v2-body">
      <TawkChat />

      <div className="v2-hero">
        <img
          src={process.env.REACT_APP_URL_TRUE_CONNECTIONS_BANNER}
          className="v2-hero-bg"
          alt="Mimo Cupido Casal"
          loading="eager"
        />
        <div className="v2-container">
          <div className="v2-hero-content">
            <h1>
              Conexões Verdadeiras <br />
              <span className="v2-gold-text">
                Onde o Sucesso Encontra a Autenticidade
              </span>
            </h1>
          </div>
        </div>
      </div>

      <section className="v2-section">
        <p>
          Em um mundo repleto de interações superficiais, encontrar conexões
          autênticas é um privilégio. No Mimo Cupido, conectamos pessoas que
          valorizam respeito, ambição e um estilo de vida sofisticado.
        </p>
      </section>

      <section className="v2-section">
        <h2>O que define uma conexão de alto padrão?</h2>
        <p>
          Uma conexão verdadeira vai além do visual. Ela envolve
          compatibilidade, propósito e valores alinhados.
        </p>
      </section>

      <section className="v2-section">
        <h2>Segurança e privacidade</h2>
        <p>
          Privacidade é prioridade. Criamos um ambiente seguro para conexões
          reais, com moderação ativa e perfis verificados.
        </p>
      </section>

      <section className="v2-section">
        <h2>Perfis verificados</h2>
        <p>
          Todos os perfis passam por validação para garantir autenticidade e
          qualidade na comunidade.
        </p>
      </section>
    </div>
  );
};

export default TrueConnectionsScreen;
